export default __webpack_public_path__ + "static/media/frequency.4ba305f7.svg";